module.exports = __webpack_public_path__ + "static/favicon-3b420f5c9a5c64ee7d2481ae59ad6596.ico";